// js
import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import AreaCard from '../common/AreaCard';


function KeyGoalsCard({area, isActiveArea, dsa, progress, toggle, canToggle, canActivateArea }) {

  let handleChange = () => {
    const dsaArea = dsa.dsaAreas.find(a => a.area === area.id);
    toggle(dsaArea.id, !dsaArea.active);
  };
  const isToggleChecked = canActivateArea && isActiveArea;
  const isToggleDisabled = !canActivateArea || (!canToggle && isActiveArea);

  return (
    <AreaCard area={area}>
      <p>
        <span className='area-card__answered key-goals-card__answered'>
          {progress.current === progress.total && <i className='icon icon-check-green' /> }
          {`${progress.current}/${progress.total} Answered`}
        </span>
      </p>
      <Toggle
        checked={isToggleChecked}
        onChange={handleChange}
        disabled={isToggleDisabled}
      />
    </AreaCard>
  );
}

KeyGoalsCard.propTypes = {
  area: PropTypes.object.isRequired,
  dsa: PropTypes.object,
  isActiveArea: PropTypes.bool,
  progress: PropTypes.object,
  toggle: PropTypes.func,
  canToggle: PropTypes.bool,
  canActivateArea: PropTypes.bool
};

export default KeyGoalsCard;



// WEBPACK FOOTER //
// ./src/components/goals/KeyGoalsCard.js